"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthWrapper = void 0;
var react_1 = __importDefault(require("react"));
var AuthWrapper = function (_a) {
    var children = _a.children, bgImageURL = _a.bgImageURL, appLogoURL = _a.appLogoURL, _b = _a.title, title = _b === void 0 ? 'Login' : _b, subTitle = _a.subTitle;
    return (react_1.default.createElement("div", { className: "auth-layout", style: {
            background: bgImageURL
                ? 'url("' + bgImageURL + '") no-repeat center center fixed'
                : '#212121',
        } },
        react_1.default.createElement("div", { className: "auth-box" },
            react_1.default.createElement("img", { src: appLogoURL, alt: "logo", className: "app-logo", loading: "lazy" }),
            react_1.default.createElement("span", { className: "auth-title" }, title),
            subTitle && react_1.default.createElement("span", { className: "auth-subtitle desc" }, subTitle),
            children)));
};
exports.AuthWrapper = AuthWrapper;
//# sourceMappingURL=AuthWrapper.js.map